import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
    return (
        <>
            <div className='d-flex align-items-center justify-content-center' style={{ height: '100vh' }}>
                <div className='section-not-found text-center'>
                    <h1 className='error-not-found text-center'>404</h1>
                    <div className='page text-center'>Ooops!!! The page you are looking for is not found</div>
                    <button className='back-home'>
                        <Link to='/dashboard' className='link_404' style={{ textDecoration: 'none', color: '#000' }}>Go to Home</Link>
                    </button>
                </div>
            </div>
        </>
    )
}

export default NotFound;